import { render, staticRenderFns } from "./libraryresource.html?vue&type=template&id=5d977b7c&scoped=true&"
import script from "./libraryresource.js?vue&type=script&lang=js&"
export * from "./libraryresource.js?vue&type=script&lang=js&"
import style0 from "./libraryresource.sass?vue&type=style&index=0&id=5d977b7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d977b7c",
  null
  
)

component.options.__file = "libraryresource.vue"
export default component.exports